import { container } from "tsyringe";
import { DispatchApiRepository } from "../../repositories/api/DispatchApiRepository";
import ApiService from "../../services/ApiService";
import { DispatchMapper } from "@/data/persistences/mappers/DispatchMapper";
import { DispatchEndpoint } from "../../endpoints/DispatchEndpoint";
import { DispatchPresenter } from "@/app/ui/presenters/DispatchPresenter";

export class DispatchComponent {
  public static init() {
    container.register<DispatchApiRepository>(DispatchApiRepository, {
      useFactory: d => {
        return new DispatchApiRepository(
          d.resolve(ApiService),
          d.resolve(DispatchMapper),
          d.resolve(DispatchEndpoint)
        );
      }
    });
    container.register<DispatchMapper>(DispatchMapper, {
      useClass: DispatchMapper
    });
    container.register<DispatchPresenter>(DispatchPresenter, {
      useFactory: d => {
        return new DispatchPresenter(d.resolve(DispatchApiRepository));
      }
    });
  }
}
